import { ReactNode } from 'react';

import styles from './DivMarker.module.scss';

export const DivMarker = (icon: ReactNode, backgroundColor?: string) => {
  let stylesOverwrite = {
    backgroundColor: 'unset',
  };

  if (backgroundColor) {
    stylesOverwrite.backgroundColor = backgroundColor;
  }

  return (
    <div className={styles.DivMarker} style={stylesOverwrite}>
      {icon}
    </div>
  );
};
